import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { Alert, Modal } from 'react-bootstrap';
import { BsExclamationCircle } from "react-icons/bs";
import PageTitle from '../../components/pageTitle/PageTitle';
import styles from './discounts.module.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import axiosRequest from '../../services/axios/axiosRequest';
import AppContext from '../../contexts/Appcontext';
import Countdown from '../../components/countdown/Countdown';
import { Button } from '@mui/material';


export default function Discounts() {

  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const { hasDiscount, setHasDiscount } = useContext(AppContext);
  // Description Modal
  const [isShowingDescriptionModal, setIsShowingDescriptionModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});

  useEffect(() => {
    hasDiscount && setHasDiscount(false);
    const productsController = new AbortController();
    axiosRequest.get('/discounts/', { signal: productsController.signal })
      .then(res => {
        setProducts(res.data);
        console.log(res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false));
    return () => productsController.abort();
  }, []);

  function showDiscountDescription(product) {
    setSelectedProduct(product);
    setIsShowingDescriptionModal(true);
  }


  return (
    <>
      <Helmet>
        <title>فروش ویژه - نوآوران پژوه</title>
        <meta name='description' content='تخفیفات، فروش ویژه و آفر های شرکت نوآوران پژوه' />
      </Helmet>
      
      <Header />
      <main className="mainContainer container-lg">
        <PageTitle title="فروش ویژه" style={{ marginBottom: "1rem" }} />
        {isLoading ? (
          <section className={styles.container}>
            {/* Skeleton Loading */}
            {Array.from({ length: 6 }).map((_, index) => (
              <div className={`${styles.skeletonCard}`} key={index}>
                <div className={`${styles.skeletonImage}`}></div>
                <div className={`${styles.skeletonTitle}`}></div>
                <div className={`${styles.skeletonBrand}`}></div>
                <div className={`${styles.skeletonPrice}`}></div>
                <div className={`${styles.skeletonCountdown}`}></div>
                <div className={`${styles.skeletonDescButton}`}></div>
              </div>
            ))}
          </section>
        ) : (
          <>
            {products.length > 0 ? (
              <section className={styles.container}>
                {products.map((product) => (
                  <div className={styles.card_container} key={product.id}>
                    <img className={styles.badge} src="/assets/images/discounts/discount.png" alt={`${product.discount}%`} />
                    <span className={styles.percent}>
                      {parseInt(product.discount_percent) > 0 && <>% {parseInt(product.discount_percent)}</>}
                    </span>
                    <Card className={styles.card}>
                      <CardActionArea>
                        <div>
                          <CardMedia className={styles.image}
                            component="img"
                            height="150"
                            image={product.image ? product.image : "/assets/images/noImage.jpg"}
                            alt={product.title}
                          />
                        </div>
                        <CardContent className='d-flex flex-column gap-4 lh-base'>
                          <h2 className="h6 mb-0 text-center">{product.name} {product.cat && `(${product.cat})`}</h2>
                          <p>برند: {product.brand}</p>
                          <div className={`${styles.price} d-flex flex-column flex-sm-row column-gap-2`}>
                            <p>قیمت:</p>
                            <div className="d-flex gap-2">
                              {(Number(product.discount_price)) ?
                                <>
                                  <span className={styles.oldPrice}>{Number(product.price).toLocaleString("fa-IR")} ریال</span>
                                  <span className={styles.newPrice}>{Number(product.discount_price).toLocaleString("fa-IR")} ریال</span>
                                </>
                                :
                                <span>تماس</span>
                              }
                            </div>
                          </div>
                          <div className={styles.deadline}>
                            <Countdown ttl={Number(product.ttl)} />
                          </div>
                          <Button className={styles.descButton} type='button' variant='outlined' color='warning'
                            disabled={!product.discount_description} onClick={() => showDiscountDescription(product)}
                          >
                            توضیحات
                          </Button>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </div>
                ))}
              </section>
            ) : (
              <Alert variant="warning">
                <BsExclamationCircle className="fs-5" /> متاسفانه در حال حاضر هیچ کالایی مشمول تخفیف نمی باشد
              </Alert>
            )}
          </>
        )}
      </main>
      <Footer />

      <Modal show={isShowingDescriptionModal} centered>
        <Modal.Header className='d-flex justify-content-between align-items-center'>
          <Modal.Title>{selectedProduct.name}</Modal.Title>
          {selectedProduct.image && <img className={styles.modalImage} src={selectedProduct.image} alt={selectedProduct.name} />}
        </Modal.Header>
        <Modal.Body>
          <p className={`${styles.modalDescription} text-muted`}>{selectedProduct.discount_description}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className={styles.closeModalButton} variant="contained" color='warning' onClick={() => setIsShowingDescriptionModal(false)}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
